<section class="step-progress" [attr.aria-labelledby]="headingId" [attr.data-step-bypass-editor]="bypassMode ? '' : null">
  <ng-template #progressHeader
    ><h4 [id]="headingId" tabindex="-1">{{ bypassMode ? 'Bypass' : 'Step progress' }}</h4></ng-template
  >
  <ui-panel [headerTemplate]="progressHeader" [noGrow]="true">
    <div class="step-progress__content">
      <p *ngIf="!bypassMode">
        Standard progress describes this visit's work. It is separate from the
        workflow's business status, such as Returned.
      </p>
      <ol *ngIf="!bypassMode" class="step-progress__states">
        <li>
          <strong>Pending</strong
          ><span>Waiting for someone to take the work.</span>
        </li>
        <li>
          <strong>Assigned</strong
          ><span>Assigned to a person, who has not started yet.</span>
        </li>
        <li>
          <strong>In progress</strong><span>Staff have started the work.</span>
        </li>
        <li>
          <strong>Completed</strong><span>The step's work is finished.</span>
        </li>
        <li *ngIf="ownerView === 'full'">
          <strong>Bypassed <small>Optional</small></strong
          ><span
            >A configured condition makes this step unnecessary. Its reason
            stays in the process history.</span
          >
        </li>
      </ol>
      <p *ngIf="usesLegacyProgress && !bypassMode" class="step-progress__legacy">
        This existing step starts immediately when work arrives. Choose a start
        setting below to use Pending and Assigned in the next published version.
        Existing runs retain their version's behavior.
      </p>
      <p *ngIf="bypassMode">A predefined condition can make this visit unnecessary when work arrives. Its explanation stays in the process history.</p>
      <p *ngIf="bypassMode && !values.startMode" role="status">Choose how work starts in the Statuses overview before applying a bypass. The existing immediate-start behavior is retained until you choose.</p>
      <ng-container *ngIf="!retainedIssue; else unsupportedProgress">
      <ui-form *ngIf="editorView as editor"
        [instanceId]="formInstanceId"
        [config]="editor.config"
        [formValues]="values"
        [disabled]="disabled"
        (formValuesChange)="onValuesChange($event, editor.origin)"
      />
      </ng-container>
      <ng-template #unsupportedProgress><p role="status">{{ retainedIssue }}</p><details><summary>Saved step progress settings</summary><pre>{{ retainedConfiguration | json }}</pre></details></ng-template>
      <p *ngIf="!bypassMode && (values.startMode === 'manual' || values.startMode === 'assigned_open')">
        {{
          values.startMode === "manual"
            ? "Opening the page does not start work with this setting. Staff choose Start work."
            : "Opening the page starts work only for the assigned person. Staff can also choose Start work."
        }}
        Completing or bypassing a step does not replace the workflow status.
      </p>
      <section *ngIf="ownerView === 'overview'" class="step-progress__bypass-summary" aria-label="Retained bypass">
        <h5>Bypass</h5>
        <p>{{ retainedIssue ? 'The saved progress policy is unavailable for editing. Its original configuration is retained.' : retainedBypass ? 'This step retains a configured bypass. It is checked when work arrives and does not satisfy normal completion requirements.' : 'No bypass is configured for this step.' }}</p>
        <details *ngIf="retainedBypass"><summary>Saved bypass configuration</summary><pre>{{ retainedBypass | json }}</pre></details>
      </section>
      <ng-container *ngIf="ownerView !== 'overview'">
      <p *ngIf="values.allowBypass && !bypassConditions.length" role="status">
        {{
          referenceLoading
            ? "Loading installed bypass conditions…"
            : "No bypass conditions are installed for this workflow. A platform administrator can provide a supported condition."
        }}
      </p>
      <p
        *ngIf="values.allowBypass && needsProcessFlag && !hasProcessFlags"
        role="status"
      >
        Add a Yes/no value in Setup → Data passed between steps, then use it
        here to indicate when the step is unnecessary.
      </p>
      <p *ngIf="values.allowBypass">
        The condition is checked when work reaches this step. Bypass uses a
        predefined rule; staff cannot skip the step from its page.
      </p>
      <p *ngIf="values.allowBypass && needsProcessFlag">
        This step is bypassed when the selected yes/no process value is Yes.
      </p>
      <div *ngIf="bypassDataView as data" class="step-progress__data-actions">
        <ui-button severity="secondary" data-add-bypass-boolean
          (click)="requestBypassData({ kind: 'add-boolean' }, data.origin, data.context, data.draft)">Add a Yes/no value</ui-button>
        <ui-button *ngIf="data.reviewKey as key" severity="secondary" data-review-bypass-field
          (click)="requestBypassData({ kind: 'review-field', key: key }, data.origin, data.context, data.draft)">Review this value</ui-button>
      </div>
      <p
        *ngIf="
          values.allowBypass &&
          needsProcessFlag &&
          values.outcomeCode !== 'bypass'
        "
        role="alert"
      >
        The saved result does not mean Yes. Correct the bypass result before
        applying these settings.
      </p>
      </ng-container>
      <p *ngIf="error" role="alert" tabindex="-1">{{ error }}</p>
      <p *ngIf="message" role="status">{{ message }}</p>
      <footer *ngIf="pending">
        <ui-button
          severity="primary"
          [disabled]="disabled"
          (click)="applyVisibleChanges()"
          >Apply step progress</ui-button
        >
        <ui-button
          severity="secondary"
          [disabled]="interactionBlocked"
          (click)="discardVisibleChanges()"
          >Cancel progress changes</ui-button
        >
      </footer>
    </div>
  </ui-panel>
</section>
